import { getCrossBrowserFullscreenElement } from 'util/fullscreen';
import { observer } from 'mobx-react-lite';
import { selectFirstScreenSharingTrack, selectIsScreenShared } from 'state/selectors';
import { useSort } from '../hooks/useSort';
import { StageProps } from '../types';
import { SpeakerStage } from './SpeakerStage';
import { ScreenShareStage } from './ScreenShareStage';
import { FullscreenShareStage } from './FullscreenShareStage';
import { RecordScreenShareStage } from './RecordScreenShareStage';

export const FocusStage = observer((props: StageProps) => {
    const { hasRecorder } = props;
    const isScreenShared = selectIsScreenShared();
    const screenTrack = selectFirstScreenSharingTrack();
    const { getSortedParticipantsWhenFocused } = useSort();
    const sortedParticipants = getSortedParticipantsWhenFocused();
    const isScreenShareMode = isScreenShared && screenTrack;

    // Выводим нужный шаблон для спикера, шаринга или шаринга на весь экран
    const fullscreenElement = getCrossBrowserFullscreenElement();
    if (isScreenShareMode && Boolean(fullscreenElement)) {
        return <FullscreenShareStage {...props} participants={sortedParticipants} screenTrack={screenTrack} />;
    }

    if (isScreenShareMode) {
        if (hasRecorder) {
            return <RecordScreenShareStage {...props} participants={sortedParticipants} screenTrack={screenTrack} />;
        }

        return <ScreenShareStage {...props} participants={sortedParticipants} screenTrack={screenTrack} />;
    }

    return <SpeakerStage {...props} participants={sortedParticipants} />;
});

FocusStage.displayName = 'FocusStage';
